var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { isShowFollow: false, visible: _vm.checkPriceVisible },
              on: {
                "update:visible": function ($event) {
                  _vm.checkPriceVisible = $event
                },
                open: _vm.opened,
              },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              !_vm.validateNull(
                this.checkPriceQuery &&
                  this.checkPriceQuery.noticeConfig &&
                  this.checkPriceQuery.noticeConfig.noticeContent
              )
                ? _c("div", [
                    _c("h2", { staticStyle: { color: "blue" } }, [
                      _vm._v(_vm._s(_vm.$t("home.annunciation1"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "white-space": "pre-line" } }, [
                      _vm._v(
                        _vm._s(
                          this.checkPriceQuery &&
                            this.checkPriceQuery.noticeConfig &&
                            this.checkPriceQuery.noticeConfig.noticeContent
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              this.checkPriceQuery && this.checkPriceQuery.chargeDetails
                ? _c(
                    "div",
                    { staticClass: "table-container-new" },
                    [
                      _c("h2", { staticStyle: { color: "blue" } }, [
                        _vm._v(_vm._s(_vm.$t("home.chargeInfoTitle"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            data: [this.checkPriceQuery.chargeDetails[0]],
                          },
                        },
                        [
                          _c(
                            "el-table-column",
                            { attrs: { prop: "label", label: "20GP" } },
                            [
                              [
                                _vm._v(
                                  "\n           " +
                                    _vm._s(
                                      _vm.validateNull(
                                        this.checkPriceQuery.chargeDetails.filter(
                                          function (item) {
                                            return item.containerType === "20GP"
                                          }
                                        )
                                      )
                                        ? ""
                                        : this.checkPriceQuery.chargeDetails.filter(
                                            function (item) {
                                              return (
                                                item.containerType === "20GP"
                                              )
                                            }
                                          )[0].ofAmount +
                                            (_vm.validateNull(
                                              this.checkPriceQuery.chargeDetails.filter(
                                                function (item) {
                                                  return (
                                                    item.containerType ===
                                                    "20GP"
                                                  )
                                                }
                                              )[0].allIn
                                            )
                                              ? ""
                                              : "(" +
                                                this.checkPriceQuery.chargeDetails.filter(
                                                  function (item) {
                                                    return (
                                                      item.containerType ===
                                                      "20GP"
                                                    )
                                                  }
                                                )[0].allIn +
                                                ")")
                                    ) +
                                    "\n          "
                                ),
                              ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            { attrs: { prop: "label", label: "40GP" } },
                            [
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.validateNull(
                                        this.checkPriceQuery.chargeDetails.filter(
                                          function (item) {
                                            return item.containerType === "40GP"
                                          }
                                        )
                                      )
                                        ? ""
                                        : this.checkPriceQuery.chargeDetails.filter(
                                            function (item) {
                                              return (
                                                item.containerType === "40GP"
                                              )
                                            }
                                          )[0].ofAmount +
                                            (_vm.validateNull(
                                              this.checkPriceQuery.chargeDetails.filter(
                                                function (item) {
                                                  return (
                                                    item.containerType ===
                                                    "40GP"
                                                  )
                                                }
                                              )[0].allIn
                                            )
                                              ? ""
                                              : "(" +
                                                this.checkPriceQuery.chargeDetails.filter(
                                                  function (item) {
                                                    return (
                                                      item.containerType ===
                                                      "40GP"
                                                    )
                                                  }
                                                )[0].allIn +
                                                ")")
                                    ) +
                                    "\n          "
                                ),
                              ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            { attrs: { prop: "label", label: "40HC" } },
                            [
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.validateNull(
                                        this.checkPriceQuery.chargeDetails.filter(
                                          function (item) {
                                            return item.containerType === "40HC"
                                          }
                                        )
                                      )
                                        ? ""
                                        : this.checkPriceQuery.chargeDetails.filter(
                                            function (item) {
                                              return (
                                                item.containerType === "40HC"
                                              )
                                            }
                                          )[0].ofAmount +
                                            (_vm.validateNull(
                                              this.checkPriceQuery.chargeDetails.filter(
                                                function (item) {
                                                  return (
                                                    item.containerType ===
                                                    "40HC"
                                                  )
                                                }
                                              )[0].allIn
                                            )
                                              ? ""
                                              : "(" +
                                                this.checkPriceQuery.chargeDetails.filter(
                                                  function (item) {
                                                    return (
                                                      item.containerType ===
                                                      "40HC"
                                                    )
                                                  }
                                                )[0].allIn +
                                                ")")
                                    ) +
                                    "\n          "
                                ),
                              ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table-column",
                            {
                              attrs: {
                                prop: "bookingTeus",
                                label: "剩余仓位（Teu）",
                              },
                            },
                            [
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.validateNull(
                                        this.checkPriceQuery.chargeDetails.map(
                                          function (item) {
                                            return item.bookingTeus
                                          }
                                        )
                                      )
                                        ? ""
                                        : this.checkPriceQuery.chargeDetails.map(
                                            function (item) {
                                              return item.bookingTeus
                                            }
                                          )[0]
                                    ) +
                                    "\n          "
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    margin: "20px 0 0px 0",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-plain-primary",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cancelButton")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-primary",
                      attrs: {
                        disabled: this.checkPriceQuery.slotTeus === 0,
                        plain: "",
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.sureButton")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }